var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pill",on:{"click":function($event){return _vm.clickPillHandler()}}},[_c('span',{class:_vm.isActive ? 'pill-text-active' : 'pill-text'},[_vm._v(_vm._s(_vm.item))])])}
var staticRenderFns = []

export { render, staticRenderFns }